import React from "react";
import { Col, Row } from "react-bootstrap";

export default function Budget() {
    return (
        <>
            <div className="aboutus_bg">
                <div className="aboutus-img-content">
                    <h1>Budget Planning & Financial Oversight</h1>
                </div>
            </div>
            <div className="container my-5">
                <div className="row">
                    {/* Main Content Section */}
                    <div className="col-lg-8 vendor-main-content">
                        <img
                            src="images/budget.jpg"
                            alt="Emergency Fund Management"
                            className="img-fluid"
                        />
                        <p>Drive financial discipline with detailed budgeting, forecasting, and performance tracking aligned to your business goals.</p>
                        <h2 style={{ fontWeight: 'bold' }}>Our Services</h2>
                        <p>
                            <ul>
                                <li><b>Customized budget development</b> <br /><br /></li>
                                <li><b>Cash flow and working capital management</b> <br /><br /></li>
                                <li><b>Variance analysis for spending control</b> <br /><br /></li>
                                <li><b>Profitability and cost center analysis</b> <br /><br /></li>
                                <li><b>Scenario financial modeling</b></li>
                            </ul>
                        </p>
                    </div>

                    {/* Sidebar Section */}
                    <div className="col-lg-4 vendor-sidebar">
                        {/* Why Choose Us */}
                        <div className="vendor-section vendor-services">
                            <h3 style={{ fontWeight: 'bold' }}>Benefits</h3>
                            <ul>
                                <li><span class="arrow">➤</span>Confident decision-making</li>
                                <li><span class="arrow">➤</span>Easier access to financing</li>
                                <li><span class="arrow">➤</span>Strategic spending alignment</li>
                                <li><span class="arrow">➤</span>Reduced financial surprises</li>
                            </ul>
                        </div>

                        {/* Latest Posts */}
                        <div className="vendor-section vendor-latest-posts" style={{ marginBottom: '20px' }}>
                            <img
                                src="images/budgetv.jpg"
                                alt="Emergency Fund Management"
                                className="img-fluid"
                            />

                        </div>
                        {/* Contact Info */}
                        {/* <div className="vendor-section vendor-contact-info">
                            <h3 style={{fontWeight:'bold'}}>Contact Info</h3>
                            <p>
                                <span> <i class="fa-solid fa-location-dot fa-xl" style={{ color: '#b80404' }}></i> </span>&nbsp;&nbsp;
                                <span>934 McCowan Road, Toronto M1P 3H6</span></p>
                            <p><i class="fa-solid fa-headset fa-xl" style={{ color: '#b80404' }}></i>&nbsp;&nbsp;+1 (647) 716-1330</p>

                            <p> <i class="fa-solid fa-envelope fa-xl" style={{ color: '#b80404' }}></i>&nbsp;&nbsp;info@rojancanada.com</p>

                        </div> */}
                    </div>
                </div>
            </div >
        </>
    );
}
